export enum Permission {
  DEBIT_HARD_CURRENCY = 'economy.hard.debit',
  CREDIT_SOFT_CURRENCY = 'economy.soft.credit',
  CREDIT_HARD_CURRENCY = 'economy.hard.credit',
  ROLE_NAMES_MANAGE = 'role.names.manage',
  ROLES_MANAGE = 'roles.manage',
  ADMINS_MANAGE = 'admins.manage',
  APP_USERS_MANAGE = 'app.users.manage',
  APP_USERS_USERID_VIEW = 'app.users.userid.view',
  APP_USERS_REGISTRATION_DATE_VIEW = 'app.users.registrationdate.view',
  ADMIN_ROLES_MANAGE = 'admins.roles.manage',
  ROLE_PERMISSIONS_MANAGE = 'role.permissions.manage',
  ADMINS_NICKNAME_VIEW = 'admins.nickname.view',
  APP_USERS_LAST_ACTIVITY_DATE_VIEW = 'app.users.lastactivity.view',
  ADMINS_PASSWORD_MANAGE = 'admins.password.manage',
  ADMINS_USERID_VIEW = 'admins.userid.view',
  ADMIN_NICKNAME_MANAGE = 'admins.nickname.manage',
  ADMIN_LOGIN_MANAGE = 'admins.login.manage',
  SELF_NICKNAME_EDIT = 'self.nickname.edit',
  COMPLAINTS_VIEW = 'complaints.view',
  COMPLAINTS_DELETE = 'complaints.delete',
  COMPLAINTS_REPLY_CREATE = 'complaints.reply.create',
  BATTLES_HISTORY_VIEW = 'battles.history.view',
  ECONOMY_TXN_VIEW = 'economy.txn.view',
  ECONOMY_ITEMS_GRANT = 'economy.items.grant',
  ECONOMY_ITEMS_REVOKE = 'economy.items.revoke',
}
